export default __webpack_public_path__ + "../staticImages/advent-page-bg.jpg";